import React, { useState, useEffect } from "react";

const ChequeBookMahiti = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    fundName: "",
    bankName: "",
    bankAccount: "",
    chequeBookNo: "",
    firstChequeNo: "",
    chequeCount: "",
    lastChequeNo: "",
    date: ""
  });

  const [list, setList] = useState(() => {
    const savedList = localStorage.getItem("grampanchayat_cheque_book");
    return savedList ? JSON.parse(savedList) : [];
  });

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("grampanchayat_cheque_book", JSON.stringify(list));
  }, [list]);

  // handle input
  const handleChange = (e) => {
    const { name, value } = e.target;

    let updated = { ...formData, [name]: value };

    // auto calculate last cheque number
    if (
      name === "firstChequeNo" ||
      name === "chequeCount"
    ) {
      const first = parseInt(
        name === "firstChequeNo" ? value : updated.firstChequeNo
      );
      const count = parseInt(
        name === "chequeCount" ? value : updated.chequeCount
      );

      if (!isNaN(first) && !isNaN(count)) {
        updated.lastChequeNo = first + count - 1;
      }
    }

    setFormData(updated);
  };

  // submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.fundName || !formData.bankName || !formData.chequeBookNo) {
      alert("❌ फंड नाव, बँक नाव व चेकबुक क्रमांक आवश्यक आहे!");
      return;
    }

    setList([...list, { ...formData, id: Date.now() }]);

    setFormData({
      fundName: "",
      bankName: "",
      bankAccount: "",
      chequeBookNo: "",
      firstChequeNo: "",
      chequeCount: "",
      lastChequeNo: "",
      date: ""
    });

    alert("✅ चेकबुकची माहिती यशस्वीरित्या जोडली गेली!");
  };

  // Delete record
  const deleteRecord = (id) => {
    const updated = list.filter((record) => record.id !== id);
    setList(updated);
  };

  // Reset form
  const handleReset = () => {
    setFormData({
      fundName: "",
      bankName: "",
      bankAccount: "",
      chequeBookNo: "",
      firstChequeNo: "",
      chequeCount: "",
      lastChequeNo: "",
      date: ""
    });
  };

  return (
    <div className="cheque-container" style={{ marginTop: "2rem", padding: "0 1rem" }}>

      {/* HEADER WITH TOGGLE */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1.5rem",
        backgroundColor: "#003366",
        color: "white",
        padding: "1rem",
        borderRadius: "0.5rem"
      }}>
        <h3 style={{ margin: 0, fontSize: "1.25rem", fontWeight: "600" }}>
          💳 चेकबुकची माहिती
        </h3>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            backgroundColor: showForm ? "#dc3545" : "#28a745",
            color: "white",
            border: "none",
            padding: "0.5rem 1rem",
            borderRadius: "0.25rem",
            cursor: "pointer",
            fontSize: "0.95rem",
            fontWeight: "500"
          }}
        >
          {showForm ? "✕ बंद करा" : "➕ नवीन नोंद"}
        </button>
      </div>

      {/* FORM SECTION */}
      {showForm && (
        <div className="cheque-form-card" style={{
          backgroundColor: "white",
          padding: "2rem",
          marginBottom: "2rem",
          borderRadius: "0.5rem",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

          <div className="col-md-6">
            <label className="form-label">फंडाचे नाव *</label>
            <select
              className="form-select"
              name="fundName"
              value={formData.fundName}
              onChange={handleChange}
              required
            >
              <option value="">-- निवडा --</option>
              <option>ग्राम पाणी पुरवठा निधी</option>
              <option>सामान्य निधी</option>
            </select>
          </div>

          <div className="col-md-6">
            <label className="form-label">बँकेचे नाव *</label>
            <select
              className="form-select"
              name="bankName"
              value={formData.bankName}
              onChange={handleChange}
              required
            >
              <option value="">-- निवडा --</option>
              <option>State Bank of India</option>
              <option>Bank of Maharashtra</option>
            </select>
          </div>

          <div className="col-md-6">
            <label className="form-label">बँक खाते क्र. *</label>
            <input
              type="text"
              className="form-control"
              name="bankAccount"
              value={formData.bankAccount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">चेकबुक क्रमांक *</label>
            <input
              type="text"
              className="form-control"
              name="chequeBookNo"
              value={formData.chequeBookNo}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">पहिला चेक क्रमांक *</label>
            <input
              type="number"
              className="form-control"
              name="firstChequeNo"
              value={formData.firstChequeNo}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">चेक संख्या *</label>
            <input
              type="number"
              className="form-control"
              name="chequeCount"
              value={formData.chequeCount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">शेवट चेक क्रमांक *</label>
            <input
              type="number"
              className="form-control bg-light"
              value={formData.lastChequeNo}
              readOnly
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">तारीख *</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

        </div>

        <div className="text-center mt-4">
          <button className="btn btn-success px-4" type="submit">
            💾 जतन करा
          </button>
          <button className="btn btn-secondary px-4 ms-2" type="button" onClick={handleReset}>
            🔄 रीसेट करा
          </button>
        </div>
      </form>
        </div>
      )}

      {/* TABLE SECTION */}
      <div className="cheque-table-card" style={{
        backgroundColor: "white",
        borderRadius: "0.5rem",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        overflow: "hidden"
      }}>
        <div style={{
          backgroundColor: "#f8f9fa",
          padding: "1rem",
          borderBottom: "1px solid #dee2e6",
          fontWeight: "600",
          fontSize: "1.1rem"
        }}>
          📋 चेकबुकची यादी (एकूण: {list.length})
        </div>

        <div className="table-responsive">
          <table className="table table-bordered mb-0" style={{ marginBottom: 0 }}>
            <thead className="table-light">
              <tr>
                <th style={{ width: "5%" }}>क्र.</th>
                <th>फंड</th>
                <th>बँक</th>
                <th>खाते क्र.</th>
                <th>चेकबुक क्र.</th>
                <th>पहिला</th>
                <th>शेवट</th>
                <th>तारीख</th>
                <th style={{ width: "10%" }}>क्रिया</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center" style={{ padding: "2rem" }}>
                    📭 कोणतीही नोंद उपलब्ध नाही
                  </td>
                </tr>
              ) : (
                list.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.fundName}</td>
                    <td>{item.bankName}</td>
                    <td>{item.bankAccount}</td>
                    <td>{item.chequeBookNo}</td>
                    <td>{item.firstChequeNo}</td>
                    <td>{item.lastChequeNo}</td>
                    <td>{item.date}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => deleteRecord(item.id)}
                        style={{ width: "100%" }}
                      >
                        🗑️ हटवा
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ChequeBookMahiti;
